import _ from "lodash";

import { Check, Eye } from "phosphor-react";
import React from "react";
import useNavigation from "~/admin/hooks/useNavigation";
import Badge from "~/admin/components/Badge";
import Card from "~/admin/components/Card";
import Table from "~/admin/components/Table";
import Td from "~/admin/components/Td";
import Th from "~/admin/components/Th";
import Tr from "~/admin/components/Tr";
import Pagination from "~/admin/components/Pagination";

export default function InfluencersTab({ influencers, onPaginate }) {
  const { navigate } = useNavigation();

  return (
    <>
      {influencers.items?.length > 0 ? (
        <Card>
          <Table>
            <thead>
              <Tr>
                <Th>Nom</Th>
                <Th>Email</Th>
                <Th>Status</Th>
                <Th></Th>
              </Tr>
            </thead>
            <tbody>
              {_.orderBy(influencers.items, "lastLoginAt").map((influencer) => {
                return (
                  <Tr key={influencer.id}>
                    <Td>
                      {influencer.lastName} {influencer.firstName}
                    </Td>
                    <Td>{influencer.email}</Td>
                    <Td>
                      <Badge color="warning">
                        {influencer.user.checkStatus}
                      </Badge>
                    </Td>
                    <Td>
                      <Eye
                        className="cursor-pointer hover:text-gray-400"
                        size={24}
                        onClick={() => navigate(`influencers/${influencer.id}`)}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {influencers.items && (
            <div className="pt-4 text-center">
              <Pagination
                lastPage={influencers.lastPage}
                currentPage={influencers.currentPage}
                onPaginate={onPaginate}
              />
            </div>
          )}
        </Card>
      ) : (
        <div className="px-4 py-2 bg-green-300 text-green-700 w-fit rounded-md mx-auto flex space-x-4 items-center">
          <div className="rounded-full border w-fit border-green-700 h-fit">
            <Check />
          </div>
          <div>Il n'y a aucune demande en cours !</div>
        </div>
      )}
    </>
  );
}
